import { Pipe, PipeTransform } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'boldKeywords',
    pure: false,
    standalone: true
})


export class BoldKeywordsPipe implements PipeTransform {
  constructor(protected _sanitizer: DomSanitizer) {}

  transform(value: string): any {
    const keywords = ['Free', 'Free-to-use', 'Month-to-Month', 'Once-off']; 
    keywords.forEach(keyword => {
      if (value == null) {
        value = value
      } else {
        value = value.replace(keyword, `<strong>${keyword}</strong>`);
      }
    });

    // Bold any word starting with R followed by a number
    value = value.replace(/\b(R\d+)\b/g, '<strong>$1</strong>');

    return this._sanitizer.bypassSecurityTrustHtml(value);
  }
}